import styles from "./Header.module.css";
import Navigation from "./Navigation";

function Header({ aboutmeRef, educationRef, experiencesRef, papersRef }) {
  return (
    <div className={styles.header}>
      <h1 className={styles.logo}>CS</h1>
      <Navigation
        educationRef={educationRef}
        aboutmeRef={aboutmeRef}
        experiencesRef={experiencesRef}
        // projectsRef={projectsRef}
        papersRef={papersRef} 
      />
    </div>
  );
}
export default Header;
